module.exports = __webpack_public_path__ + "img/plus3.a42de169.png";